import { render, staticRenderFns } from "./PageMetrics.vue?vue&type=template&id=f742533c&scoped=true&"
import script from "./PageMetrics.vue?vue&type=script&setup=true&lang=js&"
export * from "./PageMetrics.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./PageMetrics.vue?vue&type=style&index=0&id=f742533c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f742533c",
  null
  
)

export default component.exports